module.exports = __webpack_public_path__ + "img/bluesky3100_10.5dc5e125.jpg";